import React, { Suspense, lazy } from 'react';
import ReactOnRails from 'react-on-rails';

// Eager: used on most pages (header/footer) or very small.
import Sidebar from 'bundles/components/Sidebar';
import SearchBar from 'bundles/components/SearchBar'
import ArticleSearchBar from 'bundles/components/articles/ArticleSearchBar'

const lazyComponent = (Component) => (props) =>
  React.createElement(
    Suspense,
    {
      fallback: React.createElement('div', {
        className: 'loading-placeholder',
        style: { minHeight: '10px' },
      }),
    },
    React.createElement(Component, props)
  );

const GoogleMapsApi = lazy(() => import('bundles/components/GoogleMapsApi'));
const GoogleMapsOne = lazy(() => import('bundles/components/GoogleMapsOne'));
const PopUpDelete = lazy(() => import('bundles/components/PopUpDelete'));
const PreviewImage = lazy(() => import('bundles/components/PreviewImage'));
const PreviewVideo = lazy(() => import('bundles/components/PreviewVideo'));
const ProfilePicture = lazy(() => import('bundles/components/ProfilePicture'));
const Events = lazy(() => import('bundles/events/Events'));
const EventsPrice = lazy(() => import('bundles/events/form/EventsPrice'));
const EventsSchedule = lazy(() => import('bundles/events/form/EventsSchedule'));
const Banners = lazy(() => import('bundles/form/components/Banners'));
const PasswordChange = lazy(() => import('bundles/form/components/PasswordChange'));
const SocialMediaCard = lazy(() => import('bundles/form/components/SocialMediaCard'));
const TimeSchedule = lazy(() => import('bundles/form/components/TimeSchedule'));
const DropZone = lazy(() => import('bundles/slideshow/components/DropZone'));
const Slideshow = lazy(() => import('bundles/slideshow/containers/Slideshow'));
const ArticleTable = lazy(() => import('bundles/todos/components/ArticleTable'));
const TopFour = lazy(() => import('bundles/todos/components/TopFour'));
const Display = lazy(() => import('bundles/todos/components/Display'));

// Grada components
const ArticleType = lazy(() => import('bundles/components/articles/ArticleType'));
const CreateArticle = lazy(() => import('bundles/components/articles/CreateArticle'));
const MostReadBoard = lazy(() => import('bundles/components/articles/MostReadBoard'));
const MenuOrderBoard = lazy(() => import('bundles/components/categories/MenuOrderBoard'));
const VideoPlayer = lazy(() => import('bundles/components/videos/VideoPlayer'));
const ListSort = lazy(() => import('bundles/components/listings/ListSort'));
const FilterSort = lazy(() => import('bundles/components/filters/FilterSort'));
const TagAppend = lazy(() => import('bundles/components/TagAppend'));
const PrintedUploadModal = lazy(() => import('bundles/components/PrintedUploadModal'));
const PrintedFilterModal = lazy(() => import('bundles/components/PrintedFilterModal'));
const RichText = lazy(() => import('bundles/form/components/RichText'));
const CopyToClipboard = lazy(() => import('bundles/components/CopyToClipboard'));
const DynamicForm = lazy(() => import('bundles/form/components/DynamicForm'));
const ServiceFeeToggle = lazy(() => import('./bundles/events/form/ServiceFeeToggle'));
const AnalyticsDashboard = lazy(() => import('bundles/components/analytics/AnalyticsDashboard'));
const TagAnalytics = lazy(() => import('bundles/components/tags/TagAnalytics'));
const TagTrafficBoard = lazy(() => import('bundles/components/tags/TagTrafficBoard'));

// This is how rails can see and use components
// We need to "register" all components in here
ReactOnRails.register({
  Sidebar,
  SearchBar,
  ArticleSearchBar,

  AnalyticsDashboard: lazyComponent(AnalyticsDashboard),
  ArticleTable: lazyComponent(ArticleTable),
  ArticleType: lazyComponent(ArticleType),
  Banners: lazyComponent(Banners),
  CreateArticle: lazyComponent(CreateArticle),
  MostReadBoard: lazyComponent(MostReadBoard),
  MenuOrderBoard: lazyComponent(MenuOrderBoard),
  CopyToClipboard: lazyComponent(CopyToClipboard),
  TopFour: lazyComponent(TopFour),
  Display: lazyComponent(Display),
  DynamicForm: lazyComponent(DynamicForm),
  DropZone: lazyComponent(DropZone),
  Events: lazyComponent(Events),
  EventsPrice: lazyComponent(EventsPrice),
  EventsSchedule: lazyComponent(EventsSchedule),
  FilterSort: lazyComponent(FilterSort),
  GoogleMapsApi: lazyComponent(GoogleMapsApi),
  GoogleMapsOne: lazyComponent(GoogleMapsOne),
  ListSort: lazyComponent(ListSort),
  PasswordChange: lazyComponent(PasswordChange),
  PreviewImage: lazyComponent(PreviewImage),
  PreviewVideo: lazyComponent(PreviewVideo),
  ProfilePicture: lazyComponent(ProfilePicture),
  PopUpDelete: lazyComponent(PopUpDelete),
  PrintedUploadModal: lazyComponent(PrintedUploadModal),
  PrintedFilterModal: lazyComponent(PrintedFilterModal),
  RichText: lazyComponent(RichText),
  ServiceFeeToggle: lazyComponent(ServiceFeeToggle),
  Slideshow: lazyComponent(Slideshow),
  SocialMediaCard: lazyComponent(SocialMediaCard),
  TagAnalytics: lazyComponent(TagAnalytics),
  TagAppend: lazyComponent(TagAppend),
  TagTrafficBoard: lazyComponent(TagTrafficBoard),
  TimeSchedule: lazyComponent(TimeSchedule),
  VideoPlayer: lazyComponent(VideoPlayer),
});
